/**
 * Created by Carsten Bühler
 * User: CBuehler on 14.07.2017
 * Copyright: xdot GmbH 2017
 */

import { FormActions, RemoteDataActions, AppContext } from 'plugin/liferay-widgets-react-web';
import SubscriptionWebApi from '../webapi/SubscriptionWebApi';
import { ClassNames, DataNames } from '../constants/Constants';
const className = ClassNames.Subscription;


export default {
    updateSubscription: (item, formId, closeForm) => FormActions.submitForm(SubscriptionWebApi.updateSubscription, item, formId, closeForm),
    addCurrentAccountSubscription: (item, formId, closeForm) => FormActions.submitForm(SubscriptionWebApi.addCurrentAccountSubscription, item, formId, closeForm),
    delete: (item, formId, closeForm) => FormActions.submitForm(SubscriptionWebApi.delete, item, formId, closeForm),
    deleteUserSubscription: (item, formId, closeForm) => FormActions.submitForm(SubscriptionWebApi.deleteUserSubscription, item, formId, closeForm),
    addOrUpdateOrDeleteMultiSubscription: (item, formId, closeForm) => FormActions.submitForm(SubscriptionWebApi.addOrUpdateOrDeleteMultiSubscription, item, formId, closeForm),

    mySubscriptionsNeeded: () => RemoteDataActions.list(DataNames.UserSubscriptions, className, {}, SubscriptionWebApi.findMySubscriptions),

};



// WEBPACK FOOTER //
// ./js/actions/SubscriptionActions.js